var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-reset-password"},[_c('MoleculeResetPassword')],1)}
var staticRenderFns = []

export { render, staticRenderFns }